"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseApiClient = exports.Operation = exports.MutateMethods = void 0;
const axios_1 = require("axios");
const commons_logs_1 = require("@deliverr/commons-logs");
var MutateMethods;
(function (MutateMethods) {
    MutateMethods["POST"] = "POST";
    MutateMethods["PUT"] = "PUT";
    MutateMethods["DELETE"] = "DELETE";
})(MutateMethods = exports.MutateMethods || (exports.MutateMethods = {}));
var Operation;
(function (Operation) {
    Operation["CREATE"] = "CREATE";
    Operation["UPDATE"] = "UPDATE";
    Operation["DELETE"] = "DELETE";
})(Operation = exports.Operation || (exports.Operation = {}));
class BaseApiClient {
    constructor(indexName, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.indexName = indexName;
        this.options = options;
        const baseUrl = options === null || options === void 0 ? void 0 : options.baseUrl;
        if (!baseUrl || baseUrl === "") {
            throw new Error("Missing mandatory base url option.");
        }
        const axiosOptions = {
            baseURL: baseUrl,
        };
        this.axios = axios_1.default.create(axiosOptions);
        if ((_a = options === null || options === void 0 ? void 0 : options.auth) === null || _a === void 0 ? void 0 : _a.token) {
            this.axios.interceptors.request.use(async (config) => {
                var _a;
                const authToken = ((_a = options === null || options === void 0 ? void 0 : options.auth) === null || _a === void 0 ? void 0 : _a.token) && (await options.auth.token());
                config.headers.Authorization = `Bearer ${authToken}`;
                return config;
            });
        }
        else if (!((_b = options === null || options === void 0 ? void 0 : options.auth) === null || _b === void 0 ? void 0 : _b.token) && ((_d = (_c = options.auth) === null || _c === void 0 ? void 0 : _c.basic) === null || _d === void 0 ? void 0 : _d.username) && ((_f = (_e = options.auth) === null || _e === void 0 ? void 0 : _e.basic) === null || _f === void 0 ? void 0 : _f.password)) {
            this.axios.defaults.auth = {
                username: (_g = options.auth) === null || _g === void 0 ? void 0 : _g.basic.username,
                password: (_h = options.auth) === null || _h === void 0 ? void 0 : _h.basic.password,
            };
        }
    }
    async search(query, params) {
        return this.axios
            .request({
            method: MutateMethods.POST,
            url: `/documents/${this.indexName}/search`,
            data: query,
            params,
        })
            .then((res) => res.data);
    }
    async mutate(op, data) {
        var _a;
        try {
            let url = "/index";
            if (((_a = this.options) === null || _a === void 0 ? void 0 : _a.bypassIngestion) === true) {
                url = "/index/direct";
            }
            const res = await this.axios.request({
                url: url,
                method: MutateMethods.POST,
                data: {
                    index: this.indexName,
                    operation: op,
                    data: data,
                },
            });
            return res.data;
        }
        catch (err) {
            commons_logs_1.log.error({ error: err }, "Error while calling POST request to index.");
        }
    }
}
exports.BaseApiClient = BaseApiClient;
//# sourceMappingURL=BaseApiClient.js.map